import _ from 'underscore';

export default function RenderService(
  $rootScope,
  $timeout,
  $state,
  SitesService,
  SettingsService,
  CreativeService
) {
  // do we need all of these exported?
  let vm;
  vm = this;
  vm.enabled = true;
  vm.settingsService = SettingsService;
  vm.settingsService.hideOptions = true;
  vm.sitesService = SitesService;
  vm.siteParam = $state.params.siteName || $state.params.site;
  vm.setSite = setSite;
  vm.handleNavState = handleNavState;
  vm.renderDemo = renderDemo;
  vm.setEnabledSite = setEnabledSite;
  vm.$timeout = $timeout;
  vm.firstRender = true;
  vm.setSite();

  $rootScope.$watch(
    () =>
      _.omit(
        CreativeService.creative,
        'mediaUrl',
        'contentStructure'
      ),
    _.debounce(vm.renderDemo, 400),
    true
  );

  return vm;

  function setSite(overrideSiteId) {
    const overrideSite = SitesService.findById(overrideSiteId);
    const siteFromSearchParams = SitesService.fromSearchParams();
    const siteFromCreative = SitesService.findById(
      CreativeService.creative.siteId
    );

    if (overrideSite) {
      vm.site = overrideSite;
    } else if (siteFromSearchParams) {
      vm.site = siteFromSearchParams;
    } else if (siteFromCreative) {
      vm.site = siteFromCreative;
    }

    vm.setEnabledSite();
  }

  function handleNavState() {
    if (vm.firstRender) {
      vm.settingsService.hideOptions = false;
      vm.firstRender = false;
    } else {
      vm.settingsService.hideOptions = true;
    }
  }

  function renderDemo() {
    if (!vm.enabled) {
      return;
    }

    vm.handleNavState();

    vm.setEnabledSite();

    vm.$timeout(() => $rootScope.$broadcast('updatePreview'));
  }

  function setEnabledSite() {
    vm.site = vm.sitesService.findEnabledSite(
      vm.site || vm.sitesService.partnerSites[0],
      CreativeService.isCreativeInstantPlay(),
      CreativeService.isEnhancedAd()
    );
  }
}

RenderService.$inject = [
  '$rootScope',
  '$timeout',
  '$state',
  'SitesService',
  'SettingsService',
  'CreativeService'
];
